module.exports = __webpack_public_path__ + "static/media/bg-spacer-palm.ba1e8c8e.svg";